module.exports = __webpack_public_path__ + "img/map_Z3.3.B.05.4fcad438.svg";